import React from "react";
import ProfileCardWhite from "../icons/profile-card-white.svg";
import ProfileCardGrey from "../icons/profile-card-grey.svg";

const ReviewDetailStepIcon = ({ show, completed }) => {
  const iconSrc = show || completed ? ProfileCardWhite : ProfileCardGrey;

  return (
    <div className="stepLeft">
      <img
        src={iconSrc}
        alt="Review Step Icon"
        // style={{ height: 24, width: 24 }}
      />
    </div>
  );
};

export default ReviewDetailStepIcon;
